export function IconLocked(props) {
    return (
        <svg
            {...props}
            xmlns="http://www.w3.org/2000/svg"
            width="100%"
            height="100%"
            viewBox="0 0 21.772 25.871"
        >
            <defs>
                <clipPath id="clip_icon_locked">
                    <path d="M0 0h21.772v25.871H0z" />
                </clipPath>
            </defs>
            <g clipPath="url(#clip_icon_locked)">
                <path d="M19.558 9.974h-.67V8A8.003 8.003 0 002.882 8v1.974h-.668A2.214 2.214 0 000 12.188v11.468a2.215 2.215 0 002.214 2.215h17.344a2.214 2.214 0 002.212-2.215V12.188a2.213 2.213 0 00-2.212-2.214m-7.718 8.239v3.163H9.93v-3.162a2 2 0 111.911 0m3.428-8.239H6.476L6.5 8a4.383 4.383 0 018.767 0z" />
            </g>
        </svg>
    );
}
